const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/sections/Finalize.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { useText } from '@cistec/common_web/utils/intlUtils';
import textMap from 'App/config/com/eCheckin/translations';
import { useIntl } from 'react-intl';

export const Finalize = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);
    const { formatMessage } = useIntl();

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: formatMessage(textMap.finalizeContent) }} />
        </ECheckinSection>
    );
});

Finalize.displayName = 'Finalize';

export default Finalize;
